import { render, staticRenderFns } from "./exp-header.vue?vue&type=template&id=2bf66b93&scoped=true&"
import script from "./exp-header.vue?vue&type=script&lang=js&"
export * from "./exp-header.vue?vue&type=script&lang=js&"
import style0 from "./exp-header.vue?vue&type=style&index=0&id=2bf66b93&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf66b93",
  null
  
)

export default component.exports